import React from 'react';
import { Hero } from '../components/Hero';
import { motion } from 'framer-motion';
import { Heart, Users, Shield, Handshake, Leaf, Zap } from 'lucide-react';
export function About() {
  const values = [{
    icon: <Heart size={40} data-id="element-131" />,
    title: 'Christ-First',
    description: 'Everything we do flows from our love for Jesus and His call to serve the least of these.'
  }, {
    icon: <Users size={40} data-id="element-132" />,
    title: 'Dignity',
    description: "We honor every person as made in God's image, treating communities as partners, not projects."
  }, {
    icon: <Shield size={40} data-id="element-133" />,
    title: 'Stewardship',
    description: 'Every dollar is sacred. We manage resources with integrity and transparency.'
  }, {
    icon: <Handshake size={40} data-id="element-134" />,
    title: 'Partnership',
    description: 'We work alongside local leaders who know their communities best.'
  }, {
    icon: <Leaf size={40} data-id="element-135" />,
    title: 'Sustainability',
    description: 'We build solutions that last, creating long-term transformation, not temporary relief.'
  }, {
    icon: <Zap size={40} data-id="element-136" />,
    title: 'Faith + Action',
    description: 'We believe faith without works is dead. Love must be tangible.'
  }];
  return <div className="pt-20" data-id="element-137">
      <Hero title="Our Story" subtitle="Love is not love until you give it away." backgroundImage="https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=1600" height="medium" data-id="element-138" />

      {/* Video Section */}
      <section id="about-video" className="py-20 bg-white" data-id="element-139">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-141">
            <h2 className="text-[var(--color-text)] mb-4" data-id="element-142">
              About The Big Love Foundation
            </h2>
            <p className="text-lg text-[var(--color-text-light)] max-w-3xl mx-auto" data-id="element-143">
              We focus on building relationships, honoring local culture, and
              collaborating with trusted community leaders to address real needs
              and create lasting impact.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="aspect-video rounded-lg overflow-hidden shadow-2xl" data-id="element-144">
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/mLVrzWa4e9g" title="Big Love - Helping Hands and Hearts" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-145"></iframe>
          </motion.div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20 bg-[var(--color-primary)]" data-id="element-146">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-148">
            <h2 className="text-white mb-6" data-id="element-149">Our Mission</h2>
            <p className="text-xl md:text-2xl text-white leading-relaxed font-semibold" data-id="element-150">
              To tangibly share God's love by providing clean water, sustainable
              power, and biblical discipleship across the globe.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[var(--color-gray-light)]" data-id="element-151">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-153">
            <h2 className="text-[var(--color-text)] mb-4" data-id="element-154">Our Values</h2>
            <p className="text-lg text-[var(--color-text-light)]" data-id="element-155">
              These principles guide everything we do.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-156">
            {values.map((value, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white rounded-lg p-8 shadow-lg text-center" data-id="element-157">
                <div className="text-[var(--color-primary)] mb-4 flex justify-center" data-id="element-158">
                  {value.icon}
                </div>
                <h3 className="text-xl text-[var(--color-text)] mb-3 font-bold" data-id="element-159">
                  {value.title}
                </h3>
                <p className="text-[var(--color-text-light)] leading-relaxed" data-id="element-160">
                  {value.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}